module.exports = __webpack_public_path__ + "img/bybit_grey_logo.32c1bdc5.png";